<script>
export default {
  name: 'nx-resource-admin',
  functional: true,
  render(createElement, { props, data, parent }) {
    const value = props.value;
    const headerName = data.headerName;
    const mappedHeaderNames = {
      action: ({ action }) => parent.$t(`message.permissions.actions.${action}`),
      page: ({ page }) => parent.$t(`message.permissions.filters.page.${page}`),
      origin: ({ origin }) => parent.$options.filters.capitalize(origin),
    };
    return createElement('td', { class: { 'text-xs-left': true } }, headerName ? mappedHeaderNames[headerName](value) : '');
  },
};
</script>
